import React, { useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SizeDetector from './containers/detectors/size.detector';
import BrandColorHandler from 'containers/detectors/brandColor.handler';
import AppRoutes from './AppRoutes';
import TourError from './TourError';
import { initSession } from './utils/sessionHelper';

import './App.scss';

document.title = '2F Visual';

function App({ error }) {
  useEffect(() => {
    // Initialize session for tracking events
    initSession();
  }, []);

  const ContentBody = useMemo(() => {
    if (error !== null) {
      return <TourError data={error} />;
    }
    return <AppRoutes />;
  }, [error]);

  return (
    <div className="App">
      <SizeDetector />
      <BrandColorHandler />
      {ContentBody}
    </div>
  );
}

App.propTypes = {
  error: PropTypes.object,
};

const mapStateToProps = ({ error }) => ({ error });

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(App);
